import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import {
    DM_Mono,
    Instrument_Serif,
    Inter,
    Magra
} from 'next/font/google'
import { Cursor } from '@/components/generals/cursor'
import { ScrollProgress } from '@/components/generals/scroll-progress'

const sans = Inter({
    subsets: ['latin']
})

const heading = Magra({
    subsets: ['latin'],
    weight: ['400', '700']
})

const serif = Instrument_Serif({
    subsets: ['latin'],
    weight: '400',
    style: ['normal', 'italic']
})

const mono = DM_Mono({
    subsets: ['latin'],
    weight: ['400', '500']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily};--font-app-serif:${serif.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps, router }): ReactNode => {
    const routeKey = router.asPath.split('#')[0].split('?')[0] || '/'
    const isArticle = router.pathname === '/journal/[slug]'

    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
            </Head>

            <ScrollProgress target={isArticle ? '#article-body' : undefined} />

            <Component
                key={routeKey}
                {...pageProps}
            />

            <div
                aria-hidden='true'
                className='paper-grain'
            />

            <Cursor />
        </div>
    )
}

export default App
